// src/components/FilterBar.js
import React, { useState } from 'react';
import Select from 'react-select';
import './FilterBar.css';

function FilterBar({ onFilterChange, cardTypeOptions, elementOptions, subElementOptions, powerOptions, corpsOptions, levelOptions, sexOptions, plusPowerTargetOptions, plusPowerOptions, chapterOptions}) {

  const checkedImgGrif = `${process.env.PUBLIC_URL}/assets/grif2.png`;
  const uncheckedImgGrif = `${process.env.PUBLIC_URL}/assets/grif1.png`;
  const checkedImgMogora = `${process.env.PUBLIC_URL}/assets/mogora2.png`;
  const uncheckedImgMogora = `${process.env.PUBLIC_URL}/assets/mogora1.png`;
  const checkedImgCosmo = `${process.env.PUBLIC_URL}/assets/cosmo2.png`;
  const uncheckedImgCosmo = `${process.env.PUBLIC_URL}/assets/cosmo1.png`;
  const checkedImgMetro = `${process.env.PUBLIC_URL}/assets/metro2.png`;
  const uncheckedImgMetro = `${process.env.PUBLIC_URL}/assets/metro1.png`;
  const checkedImgNeos = `${process.env.PUBLIC_URL}/assets/neos2.png`;
  const uncheckedImgNeos = `${process.env.PUBLIC_URL}/assets/neos1.png`;


  const [filters, setFilters] = useState({
    grif: 0,
    mogora: 0,
    cosmo: 0,
    metro: 0,
    neos: 0,
    selectedCardType: [],
    selectedElement: [],
    selectedSubElement: [],
    selectedPower: [],
    selectedCorps: [],
    selectedLevel: [],
    selectedSex: [],
    selectedPlusPowerTarget: null,
    selectedMinPlusPower: null,
    selectedMaxPlusPower: null,
    minSpeed: '',
    maxSpeed: '',
    minAge: '',
    maxAge: '',
    selectedChapter: [],
    hongkong: [],
  });

  const [isExpanded, setIsExpanded] = useState(false); // 🔹 折りたたみ状態を管理

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };


  // フィルター変更時の処理
  const updateFilters = (key, value) => {
    setFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters, [key]: value };
      onFilterChange({
        grif: updatedFilters.grif === 1 ? ['0'] : ['0', '1'],
        mogora: updatedFilters.mogora === 1 ? ['0'] : ['0', '1'],
        cosmo: updatedFilters.cosmo === 1 ? ['0'] : ['0', '1'],
        metro: updatedFilters.metro === 1 ? ['0'] : ['0', '1'],
        neos: updatedFilters.neos === 1 ? ['0'] : ['0', '1'],
        type: updatedFilters.selectedCardType.map((type) => type.value),
        element: updatedFilters.selectedElement.map((element) => element.value),
        subElement: updatedFilters.selectedSubElement.map((subElement) => subElement.value),
        power: updatedFilters.selectedPower.map((power) => power.value),
        corps: updatedFilters.selectedCorps.map((corps) => corps.value),
        level: updatedFilters.selectedLevel.map((level) => level.value),
        sex: updatedFilters.selectedSex.map((sex) => sex.value),
        plusPowerTarget: updatedFilters.selectedPlusPowerTarget ? updatedFilters.selectedPlusPowerTarget.value : null,
        minPlusPower: updatedFilters.selectedMinPlusPower ? updatedFilters.selectedMinPlusPower.value : null,
        maxPlusPower: updatedFilters.selectedMaxPlusPower ? updatedFilters.selectedMaxPlusPower.value : null,
        minSpeed: updatedFilters.minSpeed !== '' ? parseInt(updatedFilters.minSpeed, 10) : null,
        maxSpeed: updatedFilters.maxSpeed !== '' ? parseInt(updatedFilters.maxSpeed, 10) : null,
        minAge: updatedFilters.minAge !== '' ? parseInt(updatedFilters.minAge, 10) : null,
        maxAge: updatedFilters.maxAge !== '' ? parseInt(updatedFilters.maxAge, 10) : null,
        chapter: updatedFilters.selectedChapter.map((chapter) => chapter.value),
        hongkong: updatedFilters.hongkong === 1 ? ['0'] : ['0', '1'],
      });
      return updatedFilters;
    });
  };

  // react-select 用のオプションデータ変換
  const formatOptions = (options, valueKey, labelKey) =>
    options.map((option) => ({
      value: option[valueKey],
      label: option[labelKey],
    }));

  // react-select のカスタムスタイル
  const customStyles = {
    control: (base) => ({
      ...base,
      borderColor: 'gray',
      boxShadow: 'none',
      '&:hover': {
        border: '1px groove blue',
      },
    }),
  };

  return (
    <div className={`filter-container ${isExpanded ? 'expanded' : 'collapsed'}`}>
      {/* 🔹 折りたたみボタン */}
      <button className="toggle-button" onClick={toggleExpand}>
        {isExpanded ? '▲ 詳細検索を非表示' : '▼ 詳細検索を表示'}
      </button>

      {/* 🔹 フィルターバー（開閉可能） */}
      <div className="filter-bar">
      {/* グリフ */}
      <label class="checkbox-label">
        <input
          type="checkbox"
          checked={filters.grif === 1} // チェックが入っているとき `isActive = 1`
          onChange={(e) => updateFilters('grif', e.target.checked ? 1 : 0)}
          style={{display:'none'}}
        />
          {/* 画像をクリックすると切り替え */}
          <img
            src={filters.grif === 1 ? checkedImgGrif : uncheckedImgGrif}
            alt="グリフ表示切替"
            className="checkbox-image"
            style={{ cursor: 'pointer', width: '70px', height: '70px' }} // 🔹 画像をボタンとして扱う
          />
      </label>
      {/* モゴラ */}
      <label class="checkbox-label">
        <input
          type="checkbox"
          checked={filters.mogora === 1} // チェックが入っているとき `isActive = 1`
          onChange={(e) => updateFilters('mogora', e.target.checked ? 1 : 0)}
          style={{display:'none'}}
        />
          {/* 画像をクリックすると切り替え */}
          <img
            src={filters.mogora === 1 ? checkedImgMogora : uncheckedImgMogora}
            alt="モゴラ表示切替"
            className="checkbox-image"
            style={{ cursor: 'pointer', width: '70px', height: '70px' }} // 🔹 画像をボタンとして扱う
          />
      </label>
      {/* コスモ */}
      <label class="checkbox-label">
        <input
          type="checkbox"
          checked={filters.cosmo === 1} // チェックが入っているとき `isActive = 1`
          onChange={(e) => updateFilters('cosmo', e.target.checked ? 1 : 0)}
          style={{display:'none'}}
        />
          {/* 画像をクリックすると切り替え */}
          <img
            src={filters.cosmo === 1 ? checkedImgCosmo : uncheckedImgCosmo}
            alt="コスモ表示切替"
            className="checkbox-image"
            style={{ cursor: 'pointer', width: '70px', height: '70px' }} // 🔹 画像をボタンとして扱う
          />
      </label>
      {/* メトロ */}
      <label class="checkbox-label">
        <input
          type="checkbox"
          checked={filters.metro === 1} // チェックが入っているとき `isActive = 1`
          onChange={(e) => updateFilters('metro', e.target.checked ? 1 : 0)}
          style={{display:'none'}}
        />
          {/* 画像をクリックすると切り替え */}
          <img
            src={filters.metro === 1 ? checkedImgMetro : uncheckedImgMetro}
            alt="メトロ表示切替"
            className="checkbox-image"
            style={{ cursor: 'pointer', width: '70px', height: '70px' }} // 🔹 画像をボタンとして扱う
          />
      </label>
      {/* ネオス */}
      <label class="checkbox-label">
        <input
          type="checkbox"
          checked={filters.neos === 1} // チェックが入っているとき `isActive = 1`
          onChange={(e) => updateFilters('neos', e.target.checked ? 1 : 0)}
          style={{display:'none'}}
        />
          {/* 画像をクリックすると切り替え */}
          <img
            src={filters.neos === 1 ? checkedImgNeos : uncheckedImgNeos}
            alt="ネオス表示切替"
            className="checkbox-image"
            style={{ cursor: 'pointer', width: '70px', height: '70px' }} // 🔹 画像をボタンとして扱う
          />
      </label>
      <label>
        カード分類:
        <Select
          isMulti
          options={formatOptions(cardTypeOptions, 'card_type_code', 'card_type_name')}
          value={filters.selectedCardType}
          onChange={(selected) => updateFilters('selectedCardType', selected || [])}
          styles={{
            ...customStyles,
            menuPortal: (base) => ({ ...base, zIndex: 9999 }) // ドロップダウンを最前面に
          }}
          menuPortalTarget={document.body} // 🔹 ポータルを使って body に描画
          placeholder="カード分類を選択"
        />
      </label>
      <label>
        属性:
        <Select
          isMulti
          options={formatOptions(elementOptions, 'element_code', 'element_name')}
          value={filters.selectedElement}
          onChange={(selected) => updateFilters('selectedElement', selected || [])}
          styles={{
            ...customStyles,
            menuPortal: (base) => ({ ...base, zIndex: 9999 }) // ドロップダウンを最前面に
          }}
          menuPortalTarget={document.body} // 🔹 ポータルを使って body に描画
          placeholder="属性を選択"
        />
      </label>
      <label>
        サブ属性:
        <Select
          isMulti
          options={formatOptions(subElementOptions, 'element_code', 'element_name')}
          value={filters.selectedSubElement}
          onChange={(selected) => updateFilters('selectedSubElement', selected || [])}
          styles={{
            ...customStyles,
            menuPortal: (base) => ({ ...base, zIndex: 9999 }) // ドロップダウンを最前面に
          }}
          menuPortalTarget={document.body} // 🔹 ポータルを使って body に描画
          placeholder="サブ属性を選択"
        />
      </label>
      <label>
        パワー:
        <Select
          isMulti
          options={formatOptions(powerOptions, 'power_code', 'power')}
          value={filters.selectedPower}
          onChange={(selected) => updateFilters('selectedPower', selected || [])}
          styles={{
            ...customStyles,
            menuPortal: (base) => ({ ...base, zIndex: 9999 }) // ドロップダウンを最前面に
          }}
          menuPortalTarget={document.body} // 🔹 ポータルを使って body に描画
          placeholder="パワーを選択"
        />
      </label>
      <label>
        軍団:
        <Select
          isMulti
          options={formatOptions(corpsOptions, 'corps_code', 'corps_name')}
          value={filters.selectedCorps}
          onChange={(selected) => updateFilters('selectedCorps', selected || [])}
          styles={{
            ...customStyles,
            menuPortal: (base) => ({ ...base, zIndex: 9999 }) // ドロップダウンを最前面に
          }}
          menuPortalTarget={document.body} // 🔹 ポータルを使って body に描画
          placeholder="軍団を選択"
        />
      </label>
      <label>
        レベル:
        <Select
          isMulti
          options={formatOptions(levelOptions, 'level_code', 'level')}
          value={filters.selectedLevel}
          onChange={(selected) => updateFilters('selectedLevel', selected || [])}
          styles={{
            ...customStyles,
            menuPortal: (base) => ({ ...base, zIndex: 9999 }) // ドロップダウンを最前面に
          }}
          menuPortalTarget={document.body} // 🔹 ポータルを使って body に描画
          placeholder="レベルを選択"
        />
      </label>
      <label>
        性別:
        <Select
          isMulti
          options={formatOptions(sexOptions, 'sex_code', 'sex')}
          value={filters.selectedSex}
          onChange={(selected) => updateFilters('selectedSex', selected || [])}
          styles={{
            ...customStyles,
            menuPortal: (base) => ({ ...base, zIndex: 9999 }) // ドロップダウンを最前面に
          }}
          menuPortalTarget={document.body} // 🔹 ポータルを使って body に描画
          placeholder="性別を選択"
        />
      </label>
      <div className="filter-group pair-group">
        <div className="pair-group-content">
          <label>
            抜き手:
            <input
              type="number"
              value={filters.minSpeed}
              onChange={(e) => updateFilters('minSpeed', e.target.value)}
            />
          </label>
          <h6>～</h6>
          <label>
            　
            <input
              type="number"
              value={filters.maxSpeed}
              onChange={(e) => updateFilters('maxSpeed', e.target.value)}
            />
          </label>
        </div>
      </div>
      <div className="filter-group pair-group">
        <div className="pair-group-content">
          <label>
            年齢:
            <input
              type="number"
              value={filters.minAge}
              onChange={(e) => updateFilters('minAge', e.target.value)}
            />
          </label>
          <h6>～</h6>
          <label>
            　
            <input
              type="number"
              value={filters.maxAge}
              onChange={(e) => updateFilters('maxAge', e.target.value)}
            />
          </label>
        </div>
      </div>
      <div className="filter-group trio-group">
        <div className="trio-group-content">
          <label>
            ＋修正対象:
            <Select
              options={formatOptions(plusPowerTargetOptions, 'element_code', 'element_name')}
              value={filters.selectedPlusPowerTarget}
              onChange={(selected) => updateFilters('selectedPlusPowerTarget', selected)}
              styles={{
                ...customStyles,
                menuPortal: (base) => ({ ...base, zIndex: 9999 }) // ドロップダウンを最前面に
              }}
              menuPortalTarget={document.body} // 🔹 ポータルを使って body に描画
              placeholder="＋修正対象を選択"
              isClearable // 選択削除を可能にする
            />
          </label>
          <label>
            ＋修正:
            <Select
              options={formatOptions(plusPowerOptions, 'power_code', 'power')}
              value={filters.selectedMinPlusPower}
              onChange={(selected) => updateFilters('selectedMinPlusPower', selected)}
              styles={{
                ...customStyles,
                menuPortal: (base) => ({ ...base, zIndex: 9999 }) // ドロップダウンを最前面に
              }}
              menuPortalTarget={document.body} // 🔹 ポータルを使って body に描画
              placeholder="＋修正パワーを選択"
              isClearable // 選択削除を可能にする
            />
          </label>
          <h6>～</h6>
          <label>
            　
            <Select
              options={formatOptions(plusPowerOptions, 'power_code', 'power')}
              value={filters.selectedMaxPlusPower}
              onChange={(selected) => updateFilters('selectedMaxPlusPower', selected)}
              styles={{
                ...customStyles,
                menuPortal: (base) => ({ ...base, zIndex: 9999 }) // ドロップダウンを最前面に
              }}
              menuPortalTarget={document.body} // 🔹 ポータルを使って body に描画
              placeholder="＋修正パワーを選択"
              isClearable // 選択削除を可能にする
            />
          </label>
        </div>
      </div>
      <label>
        収録章:
        <Select
          isMulti
          options={formatOptions(chapterOptions, 'chapter_code', 'chapter_name')}
          value={filters.selectedChapter}
          onChange={(selected) => updateFilters('selectedChapter', selected || [])}
          styles={{
            ...customStyles,
            menuPortal: (base) => ({ ...base, zIndex: 9999 }) // ドロップダウンを最前面に
          }}
          menuPortalTarget={document.body} // 🔹 ポータルを使って body に描画
          placeholder="収録章を選択"
        />
      </label>
      <label>
        レアリティ:
        <Select
          isMulti
          options={formatOptions(sexOptions, 'hoge', 'hoge')}
          value={filters.selectedSex}
          onChange={(selected) => updateFilters('selectedSex', selected || [])}
          styles={{
            ...customStyles,
            menuPortal: (base) => ({ ...base, zIndex: 9999 }) // ドロップダウンを最前面に
          }}
          menuPortalTarget={document.body} // 🔹 ポータルを使って body に描画
          placeholder="レアリティを選択"
        />
      </label>
      <label class="checkbox-label">
        香港版カードを除外
        <input
          type="checkbox"
          checked={filters.hongkong === 1} // チェックが入っているとき `isActive = 1`
          onChange={(e) => updateFilters('hongkong', e.target.checked ? 1 : 0)}
        />
      </label>
    </div>
    </div>
  );
}

export default FilterBar;
